module.exports = "/images/search.jpg?ca1eb048b3e2f0142c70996a4c0c7d2f";